/**
 * Where a visitor who is not signed in was going, for after the sign-in: only the new-ticket page with its request
 * (a «درخواست فعال‌سازی» link from the website, a message or a page). Anything else lands as before. Kept for this tab
 * only and for half an hour, so an old one never takes a later sign-in somewhere unexpected.
 */
const STORAGE_KEY = 'mp:login-return'
const LIFETIME_MS = 30 * 60 * 1000
const ALLOWED = /^\/apps\/ticket-management\/new(\?[^#]*)?$/

const safePath = (path: string | null | undefined): string | undefined =>
  path && ALLOWED.test(path) && path.length <= 1024 ? path : undefined

export const rememberLoginReturn = (path: string) => {
  const allowed = safePath(path)
  if (!allowed || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({path: allowed, at: Date.now()}))
  } catch {
    // Without sessionStorage the sign-in simply lands where it always does.
  }
}

/** The path remembered for after the sign-in, still valid; it stays until the page it names is reached. */
export const peekLoginReturn = (): string | undefined => {
  if (typeof sessionStorage === 'undefined') return undefined
  try {
    const value = sessionStorage.getItem(STORAGE_KEY)
    if (!value) return undefined
    const parsed = JSON.parse(value) as {path?: string; at?: number}
    if (typeof parsed.at !== 'number' || Date.now() - parsed.at > LIFETIME_MS) {
      sessionStorage.removeItem(STORAGE_KEY)
      return undefined
    }
    return safePath(parsed.path)
  } catch {
    return undefined
  }
}

export const forgetLoginReturn = () => {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // Nothing was kept.
  }
}
